import { BuildingEntityNodeBase } from "building-common/buildingEntityNodes/buildingEntityNode";
import type { GeometryQuery } from "building-common/geometryQuery";
import { faceGeometryQueryNew, planeGeometryQueryNew } from "building-common/geometryQuery";
import type { WallStructuralDomain } from "building-types/structural/structuralDomainTypes";
import { faceNew, faceRepairLoopDirections } from "geom/brep";

export default class WallStructuralDomainNode extends BuildingEntityNodeBase<WallStructuralDomain> {
  private _face: GeometryQuery | undefined;
  private _plane: GeometryQuery | undefined;

  /** The face of the wall structural domain. */
  get face(): GeometryQuery {
    if (!this._face) {
      this._face = faceGeometryQueryNew(
        faceRepairLoopDirections(faceNew([this.entity.resolvedBoundary], this.entity.plane)),
      );
    }
    return this._face;
  }

  /** The plane of the wall structural domain. */
  get plane(): GeometryQuery {
    if (!this._plane) {
      this._plane = planeGeometryQueryNew(this.entity.plane);
    }
    return this._plane;
  }

  constructor(entity: WallStructuralDomain) {
    super(entity);
  }
}
